import IllumioSupportUtils from "../common/support_utils.js";
import IllumioSupportForm from "../common/support_form.js";

/**
 * Illumio client data acquisition.
 */
export class IllumioDaq {
    constructor() {
        this.data = null;

        let daq = IllumioSupportUtils.getCookie('daq');
        if (IllumioSupportUtils.isDebug) {
            console.debug(`daq: [${JSON.stringify(daq)}]`);
        }
        if (typeof daq==='undefined' || (daq && (daq!==true || daq!=='true'))) {
            this.capturePreference();
        }
    }

    capturePreference() {
        const csrf = IllumioSupportForm.getCsrf();
        if (csrf && csrf['authenticity_token']) {
            const payload = {
                authenticity_token: csrf['authenticity_token'],
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                locale: Intl.DateTimeFormat().resolvedOptions().locale,
            }
            if (IllumioSupportUtils.isDebug) {
                console.debug(payload);
            }
            $.ajax({
                dataType: 'json',
                method: 'post',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(payload),
                url: '/api/v1/session.json',
                beforeSend: this.ajaxBeforeSendHandler,
                error: this.ajaxErrorHandler,
                success: this.ajaxSuccessHandler,
            });
        } else {
            console.warn(`IllumioDaq.capturePreference(): Missing authenticity token`);
        }
    }

    ajaxBeforeSendHandler(jqXHR, settings) {
        console.debug(jqXHR);
        console.debug(settings);
    }

    ajaxErrorHandler(jqXHR, textStatus, errorThrown) {
        // console.debug(jqXHR);
        // console.error(textStatus);
        console.error(errorThrown);
    }

    ajaxSuccessHandler(data, textStatus, jqXHR) {
        this.data = data;
        console.debug(`IllumioDaq: Successfully captured Illumio DAQ`);
        console.info(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);
    }
}
